function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea")
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = "0"
    textArea.style.left = "0"
    textArea.style.position = "fixed"

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    var success
    try {
        var successful = document.execCommand("copy")
        success = successful
    } catch (err) {
        success = false
    }

    document.body.removeChild(textArea)
    return success
}

export async function copyTextToClipboard(text) {
    let success
    if (!navigator.clipboard) {
        success = fallbackCopyTextToClipboard(text)
        return
    }
    await navigator.clipboard.writeText(text).then(
        function () {
            success = true
        },
        function (err) {
            success = false
        }
    )
    return success
}
